import React, { useState } from "react";
import "./Mobilenavbar.css";
import { Link } from "react-router-dom";

const DrawerNavbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="drawer-navbar">
      <div className="navbar-header">
        <button className="menu-icon" onClick={() => setDrawerOpen(true)}>
          ☰
        </button>
        {/* <h3 className="navbar-title">Manager Panel</h3> */}
      </div>

      <div className={`drawer-menu ${drawerOpen ? "open" : ""}`}>
        <span className="company-logo"> <img src='/Images/manureva-logo.png' alt='1'/> </span>
        <button className="close-btn" onClick={() => setDrawerOpen(false)}>
          ✕
        </button>

        <Link to="/managerdashboard" onClick={() => setDrawerOpen(false)}>Dashboard</Link>
        <Link to="/calender" onClick={() => setDrawerOpen(false)}>Calender</Link>
        <Link to="/team" onClick={() => setDrawerOpen(false)}>Team</Link>
        <Link to="/pendingapprovals" onClick={() => setDrawerOpen(false)}>Approvals</Link>
        {/* <Link to="/logout" onClick={() => setDrawerOpen(false)}>Logout</Link> */}
      </div>

      {drawerOpen && (
        <div className="overlay" onClick={() => setDrawerOpen(false)}></div>
      )}
    </div>
  );
};

export default DrawerNavbar;




































// import React, { useState } from "react";
// import "./Mobilenavbar.css";
// import { Link } from "react-router-dom";

// const DrawerNavbar = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   return (
//     <div className="drawer-navbar">
//       <div className="navbar-header">
//         <button className="menu-icon" onClick={() => setDrawerOpen(!drawerOpen)}>
//           ☰
//         </button>
       
//       </div>

//       <div className={`drawer-menu ${drawerOpen ? "open" : ""}`}>
//         <button className="close-btn" onClick={() => setDrawerOpen(false)}>
//           ✕
//         </button>
//         </div>

//       <div className={`drawer-menu ${drawerOpen ? "open" : ""}`}>
//         <Link to="/manager-dashboard">Dashboard</Link>
//         <Link to="/manager-approvals">Approvals</Link>
//         <Link to="/employees">Employees</Link>
//         <Link to="/profile">My Profile</Link>
//         <Link to="/logout">Logout</Link>
//       </div>

//       {drawerOpen && (
//         <div
//           className="overlay"
//           onClick={() => setDrawerOpen(false)}
//         ></div>
//       )}
//     </div>
//   );
// };

// export default DrawerNavbar;
